module.exports = __webpack_public_path__ + "static/media/Artboard19.d3865b5b.png";